import { render, staticRenderFns } from "./AgencyDashboard.vue?vue&type=template&id=52de5c3a"
import script from "./AgencyDashboard.vue?vue&type=script&lang=js"
export * from "./AgencyDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports